import { render, staticRenderFns } from "./SettingsServices.vue?vue&type=template&id=01ccc5ab&scoped=true"
import script from "./SettingsServices.vue?vue&type=script&lang=js"
export * from "./SettingsServices.vue?vue&type=script&lang=js"
import style0 from "./SettingsServices.vue?vue&type=style&index=0&id=01ccc5ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ccc5ab",
  null
  
)

export default component.exports